import { t } from '@avalara/bat-apps-shared/i18n';
import { SIcon } from '@avalara/skylab-sdk/react';

type Props = {
  isSelected: boolean;
  planName: string;
  disableButton?: boolean;
};

const getButtonClasses = (isSelected: boolean, disabled?: boolean) =>
  isSelected && !disabled ? 'secondary active icon-leading' : 'secondary';

const SelectPlanButton = ({ isSelected, planName, disableButton }: Props) => (
  <button
    type='button'
    className={getButtonClasses(isSelected, disableButton)}
    data-ref={`${planName}-option`}
    disabled={disableButton}
    aria-label={`select-${planName}-button`}
  >
    {isSelected && !disableButton && <SIcon name='check' />}
    <span>{t('client.buttons.get-this-plan')}</span>
  </button>
);

export default SelectPlanButton;
